import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react-lite';

import MessagePropType from '../definitions/MessagePropType';
import Question from '../components/Question';


function QuestionAddress({
    name,
    value,
    fieldOptions,
    labelMessageVariant,
    labelMessage,
    tooltipMessage,
    children,
    ...otherProps
}) {
    return (
        <Question
            field={{
                name,
                value: value,
                type: 'address',
                ...fieldOptions,
            }}
            labelMessage={labelMessage ?? getDefaultMessage(labelMessageVariant)}
            tooltipMessage={tooltipMessage}
            {...otherProps}
        >
            {children}
        </Question>
    );
}

const DEFAULT_MESSAGE_STYLES = [ 'brief', 'conversational', 'conversational-insure', 'street-address' ];

QuestionAddress.propTypes = {
    name: PropTypes.string,
    value: PropTypes.object,
    fieldOptions: PropTypes.shape({
        required: PropTypes.bool,
        disabled: PropTypes.bool,
        validators: PropTypes.arrayOf(PropTypes.object),
    }),
    labelMessageVariant: PropTypes.oneOf(DEFAULT_MESSAGE_STYLES),
    labelMessage: MessagePropType,
    tooltipMessage: MessagePropType,
    children: PropTypes.node,
};

QuestionAddress.defaultProps = {
    name: 'address',
    value: undefined,
    fieldOptions: undefined,
    labelMessageVariant: 'brief',
    labelMessage: undefined,
    children: undefined,
};


const DEFAULT_MESSAGES = {
    brief: (
        <FormattedMessage
            id="base-ui.address.label.brief"
            defaultMessage="Home address"
        />
    ),
    conversational: (
        <FormattedMessage
            id="base-ui.address.label.conversational"
            defaultMessage="What is your address?"
        />
    ),
    'conversational-insure': (
        <FormattedMessage
            id="base-ui.address.label.conversational-insure"
            defaultMessage="What is the address you would like to insure?"
        />
    ),
    'street-address': (
        <FormattedMessage
            id="base-ui.address.label.street-address"
            defaultMessage="Street address"
        />
    ),
};

function getDefaultMessage(messageStyle) {
    if (!DEFAULT_MESSAGES[messageStyle]) {
        throw new RangeError(`QuestionAddress -- argument “${messageStyle}” should have been one of “[ ${DEFAULT_MESSAGE_STYLES} ]”`);
    }

    return DEFAULT_MESSAGES[messageStyle];
}

export default observer(QuestionAddress);
